export default __webpack_public_path__ + "static/741-44714ca13d757b07c245163b3f98ddd4.gif";